<div class="forbidden-page">
  <h2>403 - Forbidden</h2>
  <p>You do not have permission to access this page.</p>
</div>
